export function checkboxGroupChecked($el, required) {
  if (!required) return true;
  const $form = $el.closest("form");
  const $checkboxGroup = $el.closest(".checkbox-group");
  const minimumSelectedCheckboxes = $checkboxGroup.data().checkboxGroupCheckedMin || 1;
  const inputs = $checkboxGroup.find('input[type="checkbox"]').toArray();
  const selectedCheckboxes = inputs.filter((input) => input.checked);
  const valid = selectedCheckboxes.length >= minimumSelectedCheckboxes;
  if (valid) {
    inputs.forEach((input) => $form.foundation("removeErrorClasses", $(input), ["checkboxGroupChecked"]));
    $form.foundation("removeErrorClasses", $el, ["checkboxGroupChecked"]);
    return true;
  }
  inputs.forEach((input) => !input.checked && $form.foundation("addErrorClasses", $(input), ["checkboxGroupChecked"]));
  return false;
}
Foundation.Abide.defaults.validators["checkboxGroupChecked"] = checkboxGroupChecked;
